<template>
  <div class="categories">
    <div v-for="category in categories" :key="category.permalink" class="category">
      <nuxt-link :to="buildUrl(category)">
				<div class="img-wrapper">
					<img v-if="category.image"
							:src="category.image"
							:alt="alternativeText(category.image_alternative_text, category.name)"
							class="responsive">
				</div>
        <h2>{{ category.name }}</h2>
        <i class="category-chevron fas fa-chevron-right px-4"/>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
	export default {
		name: "CategoriesList",
		props: {
			categories: {
				type: Array,
				required: true
			}
		},
		methods: {
			buildUrl(category) {
				return  "/categories/" + category.permalink
			},
      alternativeText(alternative_text, category_name) {
        return alternative_text || category_name + ' image'
      }
		}
	}
</script>

<style lang="scss" scoped>
    @import '@/assets/stylesheets/unstylished-headers.scss';
    @import '@/assets/stylesheets/variables.scss';

	.px-4 {
		padding-left: 4rem;
		padding-right: 4rem;
	}

	.categories {
		text-align: center;
		margin-bottom: 50px;
		grid-template-columns: repeat(auto-fit, 168px);
		grid-auto-rows: 1fr;
		justify-content: center;
		display: grid;

		.category {
			margin: 10px;

			.img-wrapper {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 170px;
			}

			img {
				display: block;
				margin: 0 auto;
				height: auto;
				width: 170px;
			}

			h2 {
				font-family: Tenez;
				font-size: 1.8rem !important;
				line-height: 1.22;
				letter-spacing: 0.9px;
				text-align: center;
				color: #151515;
			}

			.btn {
				display: block;
				border-radius: 2rem;
				border: solid 1px $color-gray-lighter;
				margin: 3px 7px;
				background-color: $color-white;
				font-size: 14px;
				line-height: 1.36;
				letter-spacing: 0.7px;
				color: #151515;
				padding: 10px 40px;
				width: auto;
				text-transform: none;
			}

			.category-chevron {
				display : none;
			}
		}
	}

        @media (max-width: 768px) {
            .categories {
                display : grid;
                grid-template-columns : 1fr;
                margin-bottom : 25px;

                .category {
                    border-bottom : 1px solid rgb(204, 204, 204);
                    margin : 0px;


                    a {
                        display : flex;
                        align-items : center;
                        padding : 11px 15px;
                        justify-content : flex-end;
                        width : 100%;

                        & > *:not(:last-child) {
                            margin-right: 24px;
                        }

												.img-wrapper {
													display: flex;
													align-items: center;
													justify-content: center;
													height: max-content;
													max-width: 60px;
												}

                        img {
													width: 100%;
													height: auto !important;
                        }

                        h2 {
                            display : flex;
                            align-items : center;
                            width : 100%;
                            min-height : 61px;
                            font-size : 2.2rem;
                            text-align : left;
                        }

                        .category-chevron {
                            font-size : 2.4rem;
                            display : block;
                        }
                    }
                }
            }
        }
</style>
